// extracted by mini-css-extract-plugin
export default {"ctn-404-page":"style_ctn-404-page__-SLKa"};